import { Data } from '../models/data';

export function deepCloneObject<T>(objectToClone: T): Data {
  let objectCloned: Data = {};
  for (let object in objectToClone) {
    if (Array.isArray(objectToClone[object])) {
      const copyArrayCloned = [];
      Object.assign(copyArrayCloned, objectToClone[object]);
      objectCloned[object] = copyArrayCloned;
    } else if (typeof objectToClone[object] === 'object') {
      objectCloned[object] = deepCloneObject(objectToClone[object]);
    } else {
      objectCloned[object] = objectToClone[object];
    }
  }
  return objectToClone != null ? objectCloned : null;
}
export const deepCloneArray = <T>(items: T[]) => items.map(deepCloneObject);
